// Import specific Firebase services
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase config object
const firebaseConfig = {
  apiKey: "AIzaSyClUDO4rvtOJsEIPiddWHvnDeszHXZf96A",
  authDomain: "starmarket-f0b1b.firebaseapp.com",
  projectId: "starmarket-f0b1b",
  storageBucket: "starmarket-f0b1b.firebasestorage.app",
  messagingSenderId: "819602972037",
  appId: "1:819602972037:web:38f17f17a4a64e2ed478ec",
  measurementId: "G-W8VNYFCP1N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get the messaging instance
const messaging = getMessaging(app);

// Register the service worker for Firebase Messaging
export const registerServiceWorker = () => {
  // Check if serviceWorker is supported
  if ("serviceWorker" in navigator) {
    // Ensure HTTPS (except for localhost during development)
    if (
      window.location.protocol === "https:" ||
      window.location.hostname === "localhost"
    ) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope: ",
            registration.scope
          );

          // Log additional info for debugging on Chrome Android
          console.log(
            "Service Worker registration is ready on Chrome for Android."
          );
        })
        .catch((err) => {
          console.error("Service Worker registration failed: ", err);

          // Suggest enabling debugging or checking permissions
          if (navigator.userAgent.includes("Android")) {
            console.error(
              "Check if notifications are enabled in Chrome on Android."
            );
          }
        });
    } else {
      console.error(
        "Service Worker requires HTTPS. Please use a secure connection."
      );
    }
  } else {
    console.warn("Service Workers are not supported by this browser.");
  }
};

// Request notification permission and get the token
export const requestNotificationPermission = async () => {
  try {
    await Notification.requestPermission();
    if (Notification.permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BBWp8NC-KxklYuyVfI8qI0CDfjEnFgHcsTK0QUD7qYjwMI5Q1hFFS5B5WFP1N1dvv9A-APZRhQog05Nrlo_tRhM",
      });
      console.log("FCM Token:", token);
      return token;
    } else {
      console.error("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting permission or FCM token:", error);
  }
};

// Set up the onMessage listener (foreground notifications)
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
      resolve(payload);
    });
  });

export default messaging;
